import { DUR, EASE } from '@/animations/vars'
import { Store } from '@/types'
import { gsap } from '@gsap'

const animatePreload = (
  comp: any,
  tl: any,
  setIsPreloaded: Store.StorePreloadAction['setIsPreloaded'],
  setStartAnimations: Store.StorePreloadAction['setStartAnimations']
) => {
  const logo = '[data-logo]'
  gsap.set(logo, { autoAlpha: 0, y: '1rem' })
  tl.current = gsap.timeline({
    paused: true,
    defaults: {
      duration: DUR.default,
      ease: EASE.out
    },
    onComplete: () => {
      setIsPreloaded(true)
      setStartAnimations(true)
    }
  })
  tl.current
    .to(logo, { autoAlpha: 1, y: 0 })
    .to(comp.current, {
      height: 0,
      ease: EASE.in,
      duration: 0.6,
      delay: DUR.default * 0.2
    })
    .to(comp.current, {
      autoAlpha: 0
    })
}

export default animatePreload
